import { lazy } from "react";
import Loadable from "components/Loadable";
import { routeConstants } from "services/keyConstants";

const MRMPlan = Loadable(lazy(() => import("../MRMPlan")));
const MinutesOfMeeting = Loadable(lazy(() => import("../MinutesOfMeeting")));
const MRMCircular = Loadable(lazy(() => import("../MRMCircular")));
const View = Loadable(lazy(() => import("../View")));

const NewMRMRoutes = [
  {
    path: routeConstants.MRM,
    children: [
      { path: "mrm-plan-list", element: <MRMPlan /> },
      { path: "mom-list", element: <MinutesOfMeeting /> },
      { path: "mrm-circular-list", element: <MRMCircular /> },
      { path: "view/:id", element: <View /> },
    ],
  },
];

export default NewMRMRoutes;
